import {
  GridItem,
  LayoutGrid,
  Tabs,
  type TabsProps,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { useGate } from 'statsig-react';

import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';
import Motion from '@/app/components/Motion';

import {
  integrationsByCategory,
  tabsByCategory,
} from '../_data/allIntegrationsData';

const IntegrationsAllIntegrations = (): JSX.Element => {
  const t = useTranslations();
  const integrationsTabsEnabled = useGate('integrations_tabs').value;

  const filteredIntegrationProps = tabsByCategory.map(([category]) =>
    integrationsByCategory.filter(
      (integration) => integration.category === category,
    ),
  );

  const tabs: TabsProps['tabs'] = tabsByCategory.map((tab) => ({
    label: t(tab[1]),
  }));

  const tabPanels: TabsProps['tabPanels'] = filteredIntegrationProps.map(
    (integrations) => ({
      content: <LandingPageIntegrations integrations={integrations} />,
    }),
  );

  return (
    <section className="py-20">
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Motion
            initial={{ opacity: 0 }}
            transition={{ delay: 0.2, duration: 0.75, type: 'tween' }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1 }}
          >
            <TypographyV3
              align="center"
              className="mb-12 lg:mb-20"
              Element="h2"
              variant="h3"
            >
              {t('integrations_select_integrations_section_title')}
            </TypographyV3>
          </Motion>
          {integrationsTabsEnabled ? (
            <Tabs scrollableTablist tabPanels={tabPanels} tabs={tabs} />
          ) : null}
        </GridItem>
      </LayoutGrid>
      {!integrationsTabsEnabled ? (
        <LandingPageIntegrations integrations={integrationsByCategory} />
      ) : null}
    </section>
  );
};

export default IntegrationsAllIntegrations;
